<br />
<mat-grid-list cols="1" rowHeight="35px">
  <mat-grid-tile rowspan="1">
    <h1 class="title">Permisos Formularios</h1>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <button mat-raised-button color="accent" name="new" (click)="openCreate()" appPermissionControl="P096B0001"><mat-icon class="icon">add</mat-icon>Nuevo</button>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <mat-form-field color="accent" appearance="outline">
      <mat-label>Buscar</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Ej. Tasa" #input appPermissionControl="P096K0001" />
      <mat-icon matSuffix color="accent">search</mat-icon>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<div id="div" class="mat-elevation-z8 table-responsive">
  <table mat-table [dataSource]="dataSource" matSort appPermissionControl="P096T0001">
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0001"></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu" appPermissionControl="P096B0002">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="openUpdate(element)" mat-menu-item appPermissionControl="P096B0003">
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
          </button>
          <button (click)="openControles(element)" mat-menu-item appPermissionControl="P096B0004">
            <mat-icon>edit</mat-icon>
            <span>Controles</span>
          </button>
          <button (click)="delete(element)" mat-menu-item appPermissionControl="P096B0005">
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>
    <ng-container matColumnDef="permissionFormId">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0002">No.</th>
      <td mat-cell *matCellDef="let element">{{ element.permissionFormId }}</td>
    </ng-container>
    <ng-container matColumnDef="formName">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0003">Formulario</th>
      <td mat-cell *matCellDef="let element">{{ element.formName }}</td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0004">Rol</th>
      <td mat-cell *matCellDef="let element">{{ element.description }}</td>
    </ng-container>
    <ng-container matColumnDef="enable">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0005">Habilitado</th>
      <td mat-cell *matCellDef="let element">{{ element.enable ? 'Si' : 'No' }}</td>
    </ng-container>
    <ng-container matColumnDef="userCreator">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0006">Usuario Creador</th>
      <td mat-cell *matCellDef="let element">{{ element.userCreator }}</td>
    </ng-container>
    <ng-container matColumnDef="create">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0007">Crear</th>
      <td mat-cell *matCellDef="let element">{{ element.create ? 'Si' : 'No' }}</td>
    </ng-container>
    <ng-container matColumnDef="read">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0008">Leer</th>
      <td mat-cell *matCellDef="let element">{{ element.read ? 'Si' : 'No' }}</td>
    </ng-container>
    <ng-container matColumnDef="update">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0009">Actualizar</th>
      <td mat-cell *matCellDef="let element">{{ element.update ? 'Si' : 'No' }}</td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P096C0010">Eliminar</th>
      <td mat-cell *matCellDef="let element">{{ element.delete ? 'Si' : 'No' }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20, 40, 80]" showFirstLastButtons class="paginatorTb"></mat-paginator>
</div>
